import { isLocalUrl } from '~/helpers/is-local-url';

/**
 * Hook that returns a custom function to be passed into `useFrameworkLink`
 * from ui-kit, implementing the correct logic for the pm-ui app.
 */
export function useShouldUseFrameworkLink(): (href: string) => boolean {
  return isLocalUrl;
}
